// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.createAiModal__czXUP {
  width: 720px;
  height: 550px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
@media (max-width: 850px) {
  .createAiModal__czXUP {
    width: 595px;
  }
}

.infoLine__d9MuZ {
  display: flex;
  align-items: center;
  padding: 10px 25px;
  border-top: 1px solid var(--tables-title-stroke);
  border-bottom: 1px solid var(--tables-title-stroke);
  background: var(--tables-title-surface);
}
@media (max-width: 850px) {
  .infoLine__d9MuZ {
    margin-bottom: 15px;
  }
}

.infoLineText__MkKP_ {
  color: var(--tables-title-text);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-transform: uppercase;
}
@media (max-width: 850px) {
  .infoLineText__MkKP_ {
    font-size: 10px;
    line-height: 12px;
  }
}

.modalBody__AXRMo {
  flex: 1;
  padding: 25px;
}

.modalBodyForm__npGkU {
  display: grid;
  grid-template-columns: 230px auto;
  column-gap: 25px;
}
@media (max-width: 850px) {
  .modalBodyForm__npGkU {
    grid-template-columns: 200px auto;
  }
}

.cardItem__wPHtT {
  min-height: 284px;
  max-height: 320px;
  max-width: 214px;
  padding: 0 15px 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 5px;
}
@media (max-width: 850px) {
  .cardItem__wPHtT {
    min-height: 245px;
  }
}

.cardItemIconWrapper__RXYGk svg {
  width: 126px;
  height: 72px;
}

.cardItemTitle__Tu0AO {
  color: var(--tables-primary-row-text-main);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-transform: uppercase;
  margin-top: 30px;
  margin-bottom: 0;
  max-width: 180px;
  line-clamp: 2;
}
@media (max-width: 850px) {
  .cardItemTitle__Tu0AO {
    font-size: 14px;
    line-height: 16px;
    margin-top: 15px;
  }
}

.cardItemDescription__mM2PB {
  color: var(--tables-secondary-row-sub-title-text);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  margin-top: 10px;
  margin-bottom: 0;
}

.modalFooter__J0lNM {
  margin-top: 15px;
  padding: 0 25px 25px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 25px;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/AddActionItemModal/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAzEF;AA2EE;EAPF;IAQI,YAAA;EAxEF;AACF;;AA2EA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gDAAA;EACA,mDAAA;EACA,uCAAA;AAxEF;AA0EE;EARF;IASI,mBAAA;EAvEF;AACF;;AA0EA;EACE,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AAvEF;AAyEE;EARF;IASI,eAAA;IACA,iBAAA;EAtEF;AACF;;AAyEA;EACE,OAAA;EACA,aAAA;AAtEF;;AAyEA;EACE,aAAA;EACA,iCAAA;EACA,gBAAA;AAtEF;AAwEE;EALF;IAMI,iCAAA;EArEF;AACF;;AAwEA;EACE,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;AArEF;AAuEE;EAVF;IAWI,iBAAA;EApEF;AACF;;AAwEE;EACE,YAAA;EACA,YAAA;AArEJ;;AAyEA;EACE,0CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;AAtEF;AAuEE;EAXF;IAYI,eAAA;IACA,iBAAA;IACA,gBAAA;EApEF;AACF;;AAuEA;EACE,iDAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AApEF;;AAuEA;EACE,gBAAA;EACA,oBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;AApEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.createAiModal {\n  width: 720px;\n  height: 550px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n  @media (max-width: 850px) {\n    width: 595px;\n  }\n}\n\n.infoLine {\n  display: flex;\n  align-items: center;\n  padding: 10px 25px;\n  border-top: 1px solid var(--tables-title-stroke);\n  border-bottom: 1px solid var(--tables-title-stroke);\n  background: var(--tables-title-surface);\n\n  @media (max-width: 850px) {\n    margin-bottom: 15px;\n  }\n}\n\n.infoLineText {\n  color: var(--tables-title-text);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n  text-transform: uppercase;\n\n  @media (max-width: 850px) {\n    font-size: 10px;\n    line-height: 12px;\n  }\n}\n\n.modalBody {\n  flex: 1;\n  padding: 25px;\n}\n\n.modalBodyForm {\n  display: grid;\n  grid-template-columns: 230px auto;\n  column-gap: 25px;\n\n  @media (max-width: 850px) {\n    grid-template-columns: 200px auto;\n  }\n}\n\n.cardItem {\n  min-height: 284px;\n  max-height: 320px;\n  max-width: 214px;\n  padding: 0 15px 15px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  border-radius: 5px;\n\n  @media (max-width: 850px) {\n    min-height: 245px;\n  }\n}\n\n.cardItemIconWrapper {\n  svg {\n    width: 126px;\n    height: 72px;\n  }\n}\n\n.cardItemTitle {\n  color: var(--tables-primary-row-text-main);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n  text-transform: uppercase;\n  margin-top: 30px;\n  margin-bottom: 0;\n  max-width: 180px;\n  line-clamp: 2;\n  @media (max-width: 850px) {\n    font-size: 14px;\n    line-height: 16px;\n    margin-top: 15px;\n  }\n}\n\n.cardItemDescription {\n  color: var(--tables-secondary-row-sub-title-text);\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 16px;\n  margin-top: 10px;\n  margin-bottom: 0;\n}\n\n.modalFooter {\n  margin-top: 15px;\n  padding: 0 25px 25px;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 25px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"createAiModal": `createAiModal__czXUP`,
	"infoLine": `infoLine__d9MuZ`,
	"infoLineText": `infoLineText__MkKP_`,
	"modalBody": `modalBody__AXRMo`,
	"modalBodyForm": `modalBodyForm__npGkU`,
	"cardItem": `cardItem__wPHtT`,
	"cardItemIconWrapper": `cardItemIconWrapper__RXYGk`,
	"cardItemTitle": `cardItemTitle__Tu0AO`,
	"cardItemDescription": `cardItemDescription__mM2PB`,
	"modalFooter": `modalFooter__J0lNM`
};
module.exports = ___CSS_LOADER_EXPORT___;
